import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function Carrito() {
  const navigate = useNavigate();
  const location = useLocation();

  const { promociones = [] } = location.state || {};

  const [items, setItems] = useState([]);

  useEffect(() => {
    const carritoGuardado =
      JSON.parse(localStorage.getItem("carritoMitico")) || [];

    const carritoNormalizado = carritoGuardado.map((item) => {
      const esCortesia =
        item.idCarrito?.startsWith("REGALO_") ||
        item.nombre?.startsWith("[CORTESÍA]") ||
        item.precio === 0;

      if (esCortesia) {
        return {
          ...item,
          cantidad: 1,
        };
      }

      return item;
    });

    setItems(carritoNormalizado);
    localStorage.setItem("carritoMitico", JSON.stringify(carritoNormalizado));
  }, []);

  const esItemCortesia = (item) => {
    return (
      item.idCarrito?.startsWith("REGALO_") ||
      item.nombre?.startsWith("[CORTESÍA]") ||
      item.precio === 0
    );
  };

  const actualizarCantidad = (index, delta) => {
    const itemActual = items[index];

    if (esItemCortesia(itemActual)) {
      return;
    }

    let nuevoCarrito = [...items];

    nuevoCarrito[index].cantidad += delta;

    if (nuevoCarrito[index].cantidad <= 0) {
      const idCarritoEliminado = nuevoCarrito[index].idCarrito;

      nuevoCarrito = nuevoCarrito.filter(
        (item, idx) =>
          idx !== index && item.regaloDeIdCarrito !== idCarritoEliminado,
      );
    }

    setItems(nuevoCarrito);
    localStorage.setItem("carritoMitico", JSON.stringify(nuevoCarrito));
  };

  const calcularTotalPesos = () => {
    let totalBruto = items.reduce(
      (sum, item) => sum + (item.precio || 0) * item.cantidad,
      0,
    );

    let descuentoTotal = 0;

    const promos2x1 = promociones.filter((p) => p.tipo === "2x1");

    promos2x1.forEach((promo) => {
      const itemEnCarrito = items.find((item) => item.id === promo.productoId);

      if (itemEnCarrito) {
        const cantidadGratis = Math.floor(itemEnCarrito.cantidad / 2);
        descuentoTotal += itemEnCarrito.precio * cantidadGratis;
      }
    });

    const totalFinal = totalBruto - descuentoTotal;
    return totalFinal > 0 ? totalFinal : 0;
  };

  const procederAlPago = () => {
    navigate("/checkout", {
      state: {
        carrito: items,
        total: calcularTotalPesos(),
        promociones: promociones,
      },
    });
  };

  return (
    <div
      style={{
        backgroundColor: "#f9f9f9",
        minHeight: "100vh",
        padding: "20px",
        fontFamily: "-apple-system, sans-serif",
      }}
    >
      <div style={{ maxWidth: "600px", margin: "0 auto" }}>
        <button
          onClick={() => navigate("/")}
          style={{
            background: "none",
            border: "none",
            color: "#666",
            fontSize: "14px",
            cursor: "pointer",
            marginBottom: "15px",
            padding: 0,
            fontWeight: "600",
          }}
        >
          ← Volver al menú
        </button>

        <h1
          style={{
            fontSize: "26px",
            fontWeight: "900",
            marginBottom: "20px",
            color: "#111",
          }}
        >
          Resumen de tu Orden
        </h1>

        {items.length === 0 ? (
          <div
            style={{
              backgroundColor: "#fff",
              padding: "40px 20px",
              borderRadius: "16px",
              textAlign: "center",
              border: "1px solid #eee",
            }}
          >
            <p style={{ color: "#777", fontSize: "15px" }}>
              Tu carrito está vacío, ¡A comer rico!
            </p>
          </div>
        ) : (
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              border: "1px solid #eee",
              padding: "20px",
              boxShadow: "0 4px 15px rgba(0,0,0,0.03)",
            }}
          >
            {items.map((item, index) => {
              const esCortesia = esItemCortesia(item);

              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "15px 0",
                    borderBottom:
                      index === items.length - 1 ? "none" : "1px solid #eee",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "800",
                        display: "block",
                        marginBottom: "4px",
                      }}
                    >
                      {item.nombre}
                    </span>

                    <span style={{ fontSize: "13px", color: "#666" }}>
                      ${item.precio} MXN unidad
                    </span>

                    {item.opcionesSeleccionadas &&
                      item.opcionesSeleccionadas.length > 0 && (
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#444",
                            marginTop: "6px",
                            backgroundColor: "#f2f6ff",
                            padding: "6px 8px",
                            borderRadius: "8px",
                            fontWeight: "600",
                            lineHeight: "1.4",
                          }}
                        >
                          {item.opcionesSeleccionadas.map((opcion, idx) => (
                            <div key={idx}>
                              {opcion.nombre}:{" "}
                              {Array.isArray(opcion.seleccion)
                                ? opcion.seleccion.join(", ")
                                : opcion.seleccion}
                            </div>
                          ))}
                        </div>
                      )}

                    {item.comentario && item.comentario.trim() !== "" && (
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#444",
                          marginTop: "6px",
                          backgroundColor: "#f7f7f7",
                          padding: "6px 8px",
                          borderRadius: "8px",
                          fontWeight: "600",
                        }}
                      >
                        Comentario: {item.comentario}
                      </div>
                    )}

                    {esCortesia && (
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#137333",
                          fontWeight: "800",
                          marginTop: "4px",
                        }}
                      >
                        Cortesía limitada a 1 pieza por promoción.
                      </div>
                    )}

                    {item.extras && item.extras.length > 0 && (
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#999",
                          marginTop: "4px",
                        }}
                      >
                        Extras: {item.extras.map((e) => e.nombre).join(", ")}
                      </div>
                    )}
                  </div>

                  {esCortesia ? (
                    <div
                      style={{
                        backgroundColor: "#e6f4ea",
                        color: "#137333",
                        borderRadius: "8px",
                        padding: "8px 12px",
                        fontSize: "13px",
                        fontWeight: "900",
                      }}
                    >
                      1
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "#f5f5f5",
                        borderRadius: "8px",
                        padding: "4px 8px",
                      }}
                    >
                      <button
                        onClick={() => actualizarCantidad(index, -1)}
                        style={{
                          border: "none",
                          background: "none",
                          fontSize: "16px",
                          fontWeight: "900",
                          cursor: "pointer",
                          color: "#111",
                          padding: "0 8px",
                        }}
                      >
                        -
                      </button>

                      <span
                        style={{
                          fontWeight: "800",
                          fontSize: "14px",
                          width: "20px",
                          textAlign: "center",
                        }}
                      >
                        {item.cantidad}
                      </span>

                      <button
                        onClick={() => actualizarCantidad(index, 1)}
                        style={{
                          border: "none",
                          background: "none",
                          fontSize: "16px",
                          fontWeight: "900",
                          cursor: "pointer",
                          color: "#111",
                          padding: "0 8px",
                        }}
                      >
                        +
                      </button>
                    </div>
                  )}
                </div>
              );
            })}

            <div
              style={{
                borderTop: "2px dashed #eee",
                marginTop: "10px",
                paddingTop: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                style={{ fontSize: "16px", fontWeight: "600", color: "#666" }}
              >
                Total Comida:
              </span>

              <span
                style={{ fontSize: "22px", fontWeight: "900", color: "#111" }}
              >
                ${calcularTotalPesos().toFixed(2)} MXN
              </span>
            </div>

            <button
              onClick={procederAlPago}
              style={{
                width: "100%",
                padding: "16px",
                backgroundColor: "#000",
                color: "white",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
                fontSize: "15px",
                fontWeight: "800",
                marginTop: "20px",
              }}
            >
              Continuar a Envío y Pago →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Carrito;
